<template>
    <!-- Modal -->
    <div class="modal" id="deleteUnavailableRoom" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">객실 사용 불가 해제</h4>
                    <button type="button" class="btn btn-m flat btn-close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="text-center mt-40">
                        <b>해당 객실의 사용 불가 상태를 해제하시겠습니까?</b>
                    </p>
                    <p class="text-center text-666 mt-15">
                        {{ getRoom(unavailableRoom.roomId).roomNumber}} / {{getRoom(unavailableRoom.roomId).roomType.roomType}} </br>
                        {{ getDateString(unavailableRoom.fromDate) }} ~ {{getDateString(unavailableRoom.toDate)}} </br></br>
                        {{ unavailableRoom.description }}
                    </p>
                    <hr style="width:auto; margin:20px -20px;background-color:#e2e2e2;">
                    <p class="text-light-blue">
                        <i class="icon-dot mr-5"></i>클릭한 날짜 외 해당 기간의 사용 불가 상태가 전부 해제됩니다.</p>
                    <div class="btn-wrap justify-content-center mt-20 mb-40">
                        <button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close">
                            <i class="icon-close mr-5"></i>취소</button>
                        <button class="btn btn-lg danger" data-dismiss="modal" aria-label="Close" @click="submit(unavailableRoom.id)">
                            <i class="icon-check mr-5"></i>해제</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CancelUnavailableModal",
        props: ['unavailableRoom', 'rooms'],
        data() {
            return {
            }
        },
        watch: {
        },
        mounted(){

        },
        methods: {
            getRoom(roomId){
                console.log(roomId);
                let unRoom = null;
                this.rooms.forEach(room => {
                    if(room.roomId == roomId) unRoom = room;
                })

                return unRoom;
            },
            getDateString(timestamp){
                return moment.unix(timestamp/1000).format('YYYY년 MM월 DD일')
            },
            submit(id){

                this.$http.delete('/api/private/booking/unAvailableRoom/'+id )
                    .then((result) => {
                        this.noti('완료', '사용 불가 객실 지정 해제를 완료하였습니다.', 'success');
                        this.$emit('init');
                    }).catch((e) =>{
                    this.noti('완료', '사용 불가 객실 지정 해제에 실패하였습니다..', 'warning');
                    console.log(e);
                })
            }
        }
    }
</script>

<style scoped>

</style>